export default __webpack_public_path__ + "static/media/Snd_q2.df5fd4da.mp3";